angular.module('workflow.app')

.factory 'DataConcierge', ( Api, $uibModal ) ->

  new class DataConcierge

    addRequest: ( subject, workflowStepId, manualStepId ) ->
      Api.ResearchRequest.save(
        subject:       subject
        workflow_step: workflowStepId
        manual_step:   manualStepId
      ).$promise

    addMessage: ( requestId, content, order ) ->
      message = new Api.ResearchRequestMessage
        request: requestId
        content: content
        order:   0

      message.$save()


    addManualStepRequest: ( workflow, workflowStep, manualStep, extra ) ->

      getRequestSubject = ( workflow, workflowStep, manualStep, extra ) ->
        extra = extra.replace(/(\r\n|\n|\r)/gm, " ")
        extraCopy = if extra then 'Extra info: ' + extra else 'No extra info provided.'

        [
          workflow.translated_query or workflow.query
          ' > '
          manualStep.name
          ' ('
          manualStep.link
          '). '
          extraCopy
        ].join( '' )

      subject = getRequestSubject( workflow, workflowStep, manualStep, extra )
      @addRequest( subject, workflowStep.id, manualStep.id )


    showManualSourceRequestModal: ( sourceWorkflowPairs ) ->
      requestModal = $uibModal.open
        template: require('./manual-source-request-modal.html')
        controller: 'ManualSourceRequestModalController'
        size: 'lg'
        resolve:
          sourceWorkflowPairs: () ->
            sourceWorkflowPairs

      requestModal.result

    showOrderModal: ( request ) ->
      requestModal = $uibModal.open
        template: require('./order-modal.html')
        controller: 'OrderModalController'
        size: 'lg'
        resolve:
          request: () ->
            request

      requestModal.result

    showRequestModal: ( request ) ->
      requestModal = $uibModal.open
        template: require('./requestModal/request-modal.html')
        controller: 'RequestModalController'
        size: 'lg'
        resolve:
          request: () ->
            request
          messages: () ->
            Api.ResearchRequestMessage.query( request: request.id ).$promise

      requestModal.result
